<mat-form-field [appearance]="appearance" [class]="fieldClass">
  <mat-select
    [value]="value"
    [disabled]="disabled"
    [placeholder]="placeholder"
    [compareWith]="compareWith"
    (selectionChange)="onSelectionChange($event.value)"
    (openedChange)="onOpenedChange($event)"
    [attr.data-pw]="dataPw"
    [class.ng-invalid]="hasError"
    [class.ng-touched]="hasError"
    [class.mat-form-field-invalid]="hasError"
    [class.mat-mdc-select-invalid]="hasError">
    <!-- Search option (only if showSearch is true) -->
    @if (showSearch) {
      <mat-option>
        <ngx-mat-select-search
          [formControl]="externalSearchControl || searchControl"
          [placeholderLabel]="searchPlaceholder"
          [noEntriesFoundLabel]="noEntriesFoundLabel"
          [attr.data-pw]="searchDataPw">
        </ngx-mat-select-search>
      </mat-option>
    }

    <!-- All option (only if showAllOption is true) -->
    @if (showAllOption) {
      <mat-option [value]="null" [attr.data-pw]="'assigned-admin-all'">
        {{ allOptionLabel }}
      </mat-option>
    }

    <!-- Unassigned option (only if showUnassignedOption is true) -->
    @if (showUnassignedOption) {
      <mat-option [value]="'unassigned'" [attr.data-pw]="'assigned-admin-unassigned'">
        Unassigned
      </mat-option>
    }

    <!-- Assigned option (only if showAssignedOption is true) -->
    @if (showAssignedOption) {
      <mat-option [value]="'assigned'" [attr.data-pw]="'assigned-admin-assigned'">
        Assigned
      </mat-option>
    }

    <!-- Admin options -->
    @for (admin of filteredAdmins; track admin) {
      <mat-option [value]="admin.id" [attr.data-pw]="'assigned-admin-' + admin.id">
        {{ admin.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
